"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbSelectLivesearch = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _classnames = _interopRequireDefault(require("classnames"));

var _shapes = require("../../skybase-core/shapes");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sbGeneralI18n = require("./sb-general-i18n");

var _sbTextbox = require("../sb-textbox");

var _constants = require("./constants");

var _constants2 = require("../sb-dropdown/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TOP = _constants2.menuPositions.TOP,
    BOTTOM = _constants2.menuPositions.BOTTOM;

var _SbSelectLivesearch = /*#__PURE__*/function (_Component) {
  _inherits(_SbSelectLivesearch, _Component);

  var _super = _createSuper(_SbSelectLivesearch);

  function _SbSelectLivesearch(props) {
    var _this;

    _classCallCheck(this, _SbSelectLivesearch);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      var onKeyDown = _this.props.onKeyDown;
      onKeyDown(event);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (event) {
      var onChange = _this.props.onChange;
      event.persist();
      event.stopPropagation();
      onChange(event.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnDelete", function (event) {
      var _event$nativeEvent, _event$nativeEvent$st, _assertThisInitialize, _assertThisInitialize2, _assertThisInitialize3;

      (_event$nativeEvent = event.nativeEvent) === null || _event$nativeEvent === void 0 ? void 0 : (_event$nativeEvent$st = _event$nativeEvent.stopImmediatePropagation) === null || _event$nativeEvent$st === void 0 ? void 0 : _event$nativeEvent$st.call(_event$nativeEvent);
      (_assertThisInitialize = _assertThisInitialized(_this)) === null || _assertThisInitialize === void 0 ? void 0 : (_assertThisInitialize2 = _assertThisInitialize.node) === null || _assertThisInitialize2 === void 0 ? void 0 : (_assertThisInitialize3 = _assertThisInitialize2.focus) === null || _assertThisInitialize3 === void 0 ? void 0 : _assertThisInitialize3.call(_assertThisInitialize2); // After pressing X button, the input looses focus, therefore focus should be restored.

      var resetLiveSearch = _this.props.resetLiveSearch;
      resetLiveSearch();
    });

    _defineProperty(_assertThisInitialized(_this), "processFocusing", function (focus) {
      var focusedElement = document.activeElement;

      if (!focus && focusedElement && focusedElement === _this.node) {
        // element has focus and should not have
        focusedElement.blur();
      } else if (focus && (!focusedElement || focusedElement !== _this.node)) {
        // element does not have focus and should have
        _this.focusNode();
      }

      _this.forceUpdate();
    });

    _this.node = null;
    return _this;
  }

  _createClass(_SbSelectLivesearch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          inputRef = _this$props.inputRef,
          autoFocus = _this$props.autoFocus;
      inputRef(this.node);
      this.processFocusing(autoFocus);
    }
  }, {
    key: "focusNode",

    /* eslint-enable no-unused-expressions */
    value: function focusNode() {
      var opened = this.props.opened;

      if (opened && this.node) {
        this.node.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          value = _this$props2.value,
          id = _this$props2.id,
          _ = _this$props2.intl.formatMessage,
          position = _this$props2.position,
          hasError = _this$props2.hasError,
          disabled = _this$props2.disabled,
          isFocused = _this$props2.isFocused,
          onFocus = _this$props2.onFocus,
          placeholder = _this$props2.placeholder;
      var iconClass = (0, _classnames.default)(_constants.AUTOCOMPLETE_ICON_CLOSE, ' autocomplete-icon');
      var liveSearchClass = (0, _classnames.default)({
        'livesearch-bottom': position === BOTTOM
      }, {
        'livesearch-top': position === TOP
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('livesearch', liveSearchClass)
      }, /*#__PURE__*/_react.default.createElement(_sbTextbox.SbTextbox, {
        value: value,
        onChange: this.handleOnChange,
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : _(_sbGeneralI18n.messages.searchForItems),
        inputRef: function inputRef(input) {
          _this2.node = input;
        },
        className: (0, _classnames.default)('sb-dropdown-livesearch', "livesearch-".concat(position)),
        autoFocus: isFocused,
        disabled: disabled,
        hasError: hasError,
        onKeyDown: this.handleKeyDown,
        addonLeft: /*#__PURE__*/_react.default.createElement("i", {
          className: "sbi-search search-icon"
        }),
        addonRight: value ? /*#__PURE__*/_react.default.createElement("span", {
          id: id,
          className: "delete-button",
          onClick: this.handleOnDelete
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: iconClass
        })) : null,
        onFocus: onFocus // this is a class for the SbTextbox, because when 'addon' is enabled, the whole structure is different.
        ,
        outerClassName: (0, _classnames.default)('sb-dropdown-livesearch-input-addon')
      }));
    }
  }]);

  return _SbSelectLivesearch;
}(_react.Component);

_defineProperty(_SbSelectLivesearch, "propTypes", {
  onChange: _propTypes.default.func.isRequired,
  onFocus: _propTypes.default.func,
  opened: _propTypes.default.bool.isRequired,
  value: _propTypes.default.string.isRequired,
  id: _propTypes.default.string.isRequired,
  resetLiveSearch: _propTypes.default.func.isRequired,
  intl: _shapes.intlShape.isRequired,
  inputRef: _shapes.PropTypeRef.isRequired,
  onKeyDown: _propTypes.default.func,
  position: _propTypes.default.oneOf([TOP, BOTTOM]),
  hasError: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  autoFocus: _propTypes.default.bool,
  isFocused: _propTypes.default.bool,
  placeholder: _propTypes.default.string
});

_defineProperty(_SbSelectLivesearch, "defaultProps", {
  position: TOP,
  hasError: false,
  disabled: false,
  autoFocus: true,
  isFocused: false,
  placeholder: null,
  onKeyDown: _constants.NOOP,
  onFocus: _constants.NOOP
});

var SbSelectLivesearch = (0, _reactIntl.injectIntl)(_SbSelectLivesearch);
exports.SbSelectLivesearch = SbSelectLivesearch;
//# sourceMappingURL=sb-select-livesearch.js.map